module.exports = __webpack_public_path__ + "img/up-arrow.355d0b05.svg";